import Swiper from 'swiper/bundle';

import 'swiper/swiper-bundle.css';

/* eslint-disable no-unused-vars */
var sliderMain = new Swiper('.slider-main', {
    slidesPerView: 1,
    slideClass: 'slider-main-slide',
    slideActiveClass: 'slider-main-slide-active',
    autoplay: {
      delay: 3200,
      disableOnInteraction: false,
    },
    speed: 300,
    pagination: {
      el: '.slider-main-pagination',
      bulletClass: 'slider-main-pagination-bar',
      bulletActiveClass: 'slider-main-pagination-bar-active',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
});
  
var sliderBrands = new Swiper('.slider-brands', {
    resistance: false,
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 12,
    pagination: {
      el: '.slider-brands-pagination',
      bulletClass: 'slider-brands-pagination-bar',
      bulletActiveClass: 'slider-brands-pagination-bar-active',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 6,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 27,
      },
    }
 });

/* eslint-enable no-unused-vars */

window.sliderMain = () => {
  return {
    largeScreen: false,
    setNavigation() {
      let viewPortWidth;
     
      // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
      if (typeof window.innerWidth != 'undefined') {
        viewPortWidth = window.innerWidth
      }
     
     // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
      else if (typeof document.documentElement != 'undefined'
      && typeof document.documentElement.clientWidth !=
      'undefined' && document.documentElement.clientWidth != 0) {
         viewPortWidth = document.documentElement.clientWidth;
      }
     
      // older versions of IE
      else {
        viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
      }

      if (viewPortWidth > 1280) {
        this.largeScreen = true;
      }

        else {
          this.largeScreen = false;
        }

      console.log(this.largeScreen);
    }
  }
}